export const rolesDataActions = {
  populateRolesData: "POPULATE_ROLES_DATA",
  rolesLoading: "ROLES_LOADING",
  rolesLoadError: "ROLES_LOAD_ERROR",
  rolesCreateLoading: "ROLES_CREATE_LOADING",
  rolesCreateReady: "ROLES_CREATE_READY"
};
